@if (settingsActive || volumeActive) {
	@if (shouldShowClosedCaptionsToggle() && !volumeActive) {
		<section
			class="captions-section settings-section"
			>
			<span translate="player-controls_subtitles"></span>
			<mat-slide-toggle
				color="primary"
				[hideIcon]="false"
				[aria-label]="('player-controls_captions' | translate)"
				class="captions-toggle"
				analytics-on="click"
				[attr.analytics-event]="player.captionsEnabled() ? 'Hide closed captions' : 'Show closed captions'"
				analytics-category="playback controls"
				[(ngModel)]="captionsEnabled"
				(change)="toggleCaps()">
			</mat-slide-toggle>
		</section>
	}
	@if (options.shouldDisplayAudioDescriptionButton && !volumeActive) {
		<section
			class="audio-description-section settings-section"
			>
			<span translate="player-controls_audio-description"></span>
			<mat-slide-toggle
				color="primary"
				[hideIcon]="false"
				[aria-label]="('player-controls_audio-description' | translate)"
				class="audio-description-toggle"
				analytics-on="click"
				[attr.analytics-event]="audioDescriptionEnabled ? 'Disable audio description' : 'Enable audio description'"
				analytics-category="playback controls"
				[(ngModel)]="audioDescriptionEnabled"
				(change)="toggleAudioDescription.emit()">
			</mat-slide-toggle>
		</section>
	}
	@if (options.toggleCommentCaptionsCallback != null && !volumeActive) {
		<section
			class="comment-captions-section settings-section"
			>
			<span translate="player-controls_overlay-comments"></span>
			<mat-slide-toggle
				color="primary"
				[hideIcon]="false"
				[aria-label]="('player-controls_overlay-comments' | translate)"
				class="comment-captions-toggle"
				[(ngModel)]="commentCaptionsEnabled"
				(change)="toggleCommentCaptions.emit()">
			</mat-slide-toggle>
		</section>
	}
	@if (options.liveStream && !volumeActive) {
		<section
			class="live-mode-section settings-section"
			data-cy="live-mode-section"
			>
			<span translate="player-controls_live-stream"></span>
			<mat-slide-toggle
				color="primary"
				[hideIcon]="false"
				[aria-label]="('player-controls_live-stream' | translate)"
				[(ngModel)]="liveMode"
				(change)="toggleLiveMode()">
			</mat-slide-toggle>
		</section>
	}
	@if (shouldShowSourceSyncAndAudio() && !(settingsActive && !isXSmallScreen)) {
		<section
			class="source-volume-section settings-section"
			>
			<span id="source-volume-label" translate="player-controls_volume1"></span>
			<div class="volume-container">
				<mat-slider
					#sourceVolumeSlider
					color="primary"
					class="volume-slider"
					[min]="0"
					[max]="100"
					[disabled]="getSourceMute() && sourceVolumeLevel !== 0"
					[attr.aria-label]="'player-controls_volume-slider_volume-handles' | translate"
					[step]="1">
					<input
						[(ngModel)]="sourceVolumeLevel"
						matSliderThumb
						role="slider"
						aria-labelledby="source-volume-label"
						[attr.aria-valuemin]="0"
						[attr.aria-valuemax]="100"
						[attr.aria-valuenow]="sourceVolumeLevel"
						(input)="updateSourceVolumeLevel(sourceSliderThumb.value)"
						#sourceSliderThumb="matSliderThumb"
						(change)="updateSourceVolumeLevel(sourceSliderThumb.value)" />
				</mat-slider>
				<button
					type="button"
					class="mute-button"
					[attr.aria-label]="(getSourceMute() ? 'microphone-unmute' : 'microphone-mute') | translate"
					(click)="toggleSourceMute()">
					<i [class]="getSourceMute() ? 'ficon-app-volume-mute' : 'ficon-app-volume-high'"></i>
				</button>
			</div>
		</section>
	}
	@if ((!options.liveStream || liveMode) && !(settingsActive && !isXSmallScreen)) {
		<section
			class="volume-section settings-section"
			>
			<span id="main-volume-label" translate="player-controls_volume-x" [translateParams]="{num: shouldShowSourceSyncAndAudio() ? '2' : ''}"></span>
			<div class="volume-container">
				<mat-slider
					#mainVolumeSlider
					color="primary"
					class="volume-slider"
					[min]="0"
					[max]="100"
					[disabled]="getMute() && volumeLevel !== 0"
					[attr.aria-label]="'player-controls_volume-slider_volume-handles' | translate"
					[step]="1">
					<input
						[(ngModel)]="volumeLevel"
						matSliderThumb
						role="slider"
						aria-labelledby="main-volume-label"
						[attr.aria-valuemin]="0"
						[attr.aria-valuemax]="100"
						[attr.aria-valuenow]="volumeLevel"
						(input)="updateVolumeLevel(volumeThumb.value)"
						#volumeThumb="matSliderThumb"
						(change)="updateVolumeLevel(volumeThumb.value)" />
				</mat-slider>
				<button
					class="mute-button"
					type="button"
					[attr.aria-label]="(getMute() ? 'microphone-unmute' : 'microphone-mute') | translate"
					(click)="toggleMute()">
					<i [class]="getMute() ? 'ficon-app-volume-mute' : 'ficon-app-volume-high'"></i>
				</button>
			</div>
		</section>
	}
	@if (options.showVolumeWarning) {
		<div class="volume-warning" translate="player-controls_source-volume-warning"></div>
	}
}
